import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from 'react-icons/hi';

const ContactUsPage = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <div className="bg-white">
            <HomeNav />
            
            {/* Contact Hero */}
            <section className="pt-32 pb-20 bg-secondary relative overflow-hidden">
                <div className="container-custom relative z-10 text-center max-w-3xl mx-auto">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Reach Out</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        We're Here to <span className="text-primary italic">Help You</span>
                    </h1>
                    <p className="text-muted-foreground text-lg mt-6">
                        Have questions about our services or need a custom quote? Our premium support team is ready to assist you.
                    </p>
                </div>
            </section>

            <section className="section-padding">
                <div className="container-custom">
                    <div className="grid lg:grid-cols-3 gap-12">
                        {/* Info Cards */}
                        <div className="lg:col-span-1 space-y-6">
                            <div className="card-premium p-8 space-y-4">
                                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                                    <HiOutlinePhone size={24} />
                                </div>
                                <div>
                                    <h4 className="font-bold text-lg">Call Us</h4>
                                    <p className="text-muted-foreground text-sm">Mon-Fri from 8am to 6pm.</p>
                                    <p className="text-primary font-black mt-2">+91 90084 25897</p>
                                </div>
                            </div>

                            <div className="card-premium p-8 space-y-4">
                                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                                    <HiOutlineMail size={24} />
                                </div>
                                <div>
                                    <h4 className="font-bold text-lg">Email Us</h4>
                                    <p className="text-muted-foreground text-sm">Our team is here to help.</p>
                                    <p className="text-primary font-black mt-2">support@astraclean.in</p>
                                </div>
                            </div>

                            <div className="card-premium p-8 space-y-4">
                                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                                    <HiOutlineLocationMarker size={24} />
                                </div>
                                <div>
                                    <h4 className="font-bold text-lg">Our Office</h4>
                                    <p className="text-muted-foreground text-sm">Visit our headquarters.</p>
                                    <p className="text-primary font-black mt-2">Bengaluru, Karnataka, India</p>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="lg:col-span-2">
                            <div className="card-premium p-10 md:p-12">
                                <h3 className="text-3xl font-black mb-8">Send us a Message</h3>
                                <form className="space-y-6">
                                    <div className="grid md:grid-cols-2 gap-6">
                                        <div className="space-y-2">
                                            <label className="text-xs font-black uppercase tracking-widest text-muted-foreground">Full Name</label>
                                            <input 
                                                type="text" 
                                                className="w-full px-6 py-4 rounded-xl bg-secondary/50 border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" 
                                                placeholder="John Doe" 
                                            />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-xs font-black uppercase tracking-widest text-muted-foreground">Email Address</label>
                                            <input 
                                                type="email" 
                                                className="w-full px-6 py-4 rounded-xl bg-secondary/50 border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" 
                                                placeholder="john@example.com" 
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-muted-foreground">Phone Number</label>
                                        <div className="flex gap-4">
                                            <select className="px-4 py-4 rounded-xl bg-secondary/50 border border-border outline-none text-sm font-bold">
                                                <option value="+91">+91</option>
                                            </select>
                                            <input 
                                                type="tel" 
                                                className="w-full px-6 py-4 rounded-xl bg-secondary/50 border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" 
                                                placeholder="90084 25897" 
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="text-xs font-black uppercase tracking-widest text-muted-foreground">Message</label>
                                        <textarea 
                                            rows="5"
                                            className="w-full px-6 py-4 rounded-xl bg-secondary/50 border border-border focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all resize-none" 
                                            placeholder="Tell us how we can help..."
                                        ></textarea>
                                    </div>

                                    <button type="submit" className="btn-primary w-full !py-5 uppercase tracking-[0.2em] text-xs font-black">
                                        Send Message
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default ContactUsPage;

